import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class CustomCustomerNotification {
  sendNotification(
    ordersListId,
    emailBody,
    emailSubject,
    smsBody,
    sendTestStatus
  ) {
    return axios.post(
      `${API_URL}custom-customer-notification/send-notification`,
      {
        ordersListId,
        emailBody,
        emailSubject,
        smsBody,
        sendTestStatus,
      },
      {
        headers: authHeader(),
      }
    );
  }
}

export default new CustomCustomerNotification();
